"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Team = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M20 8.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM21.735 19h-6.759c.016-.08.024-.163.024-.25v-5.263c0-.498-.11-.96-.304-1.376a4.84 4.84 0 002.54.712A4.837 4.837 0 0019.946 12c1.14.033 2.053.942 2.053 2.058v4.685a.261.261 0 01-.265.257zM13 14.058V19h.714c.158 0 .286-.112.286-.25v-5.263c0-.359-.086-.7-.24-1.008-.465.377-.76.945-.76 1.58z",
        clipRule: "evenodd",
        opacity: 0.6
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M11 7a3 3 0 11-6 0 3 3 0 016 0zm-3 4.984c1.303 0 2.51-.365 3.494-.984 1.412.152 2.506 1.207 2.506 2.487v5.262c0 .139-.128.251-.286.251H2.286C2.128 19 2 18.888 2 18.75v-5.263c0-1.28 1.094-2.335 2.506-2.487.984.62 2.19.984 3.494.984z",
        clipRule: "evenodd"
      }
    )
  );
};
export default Team;
